"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
const axios_1 = require("axios");
const index_1 = require("../index");
const http_retry_1 = require("./http-retry");
let HttpService = /** @class */ (() => {
    class HttpService {
        constructor() {
            this.defaultHeaderOptions = {
                authorization: '',
                'Content-Type': 'application/json',
            };
            this.timeout = 30000;
        }
        get(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params, options) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const query = Object.keys(params)
                        .map((key) => key + '=' + params[key])
                        .join('&');
                    const headers = this.setHeaders(options);
                    const response = yield axios_1.default.get(`${options.url}?${query}`, Object.assign(Object.assign({}, options), { timeout: options.timeout || this.timeout, headers }));
                    if (!this.isPaginatedResponse(response)) {
                        return response;
                    }
                    const { data: { pageCount, page, data }, } = response;
                    const finalResult = data;
                    const requests = [];
                    if (page < pageCount) {
                        let ctr = page + 1;
                        while (ctr <= pageCount) {
                            const pagedReq = axios_1.default.get(`${options.url}?${query}&page=${ctr}`, Object.assign(Object.assign({}, options), { timeout: options.timeout || this.timeout, headers }));
                            requests.push(pagedReq);
                            ctr++;
                        }
                        const allResult = yield Promise.all(requests);
                        allResult.forEach((all) => {
                            finalResult.push(...all.data.data);
                        });
                    }
                    const returnResult = Object.assign(Object.assign({}, response.data), { data: finalResult });
                    return {
                        config: response.config,
                        data: returnResult,
                        headers: response.headers,
                        status: response.status,
                        statusText: response.statusText,
                        request: response.request,
                    };
                }
                catch (error) {
                    throw error;
                }
            });
        }
        post(params, options) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const headers = this.setHeaders(options);
                    let form = params;
                    if (options.isFormData === true) {
                        form = this.toFormData(params);
                    }
                    const response = yield axios_1.default.post(options.url, form, Object.assign(Object.assign({}, options), { timeout: options.timeout || this.timeout, headers }));
                    return response;
                }
                catch (error) {
                    throw error;
                }
            });
        }
        put(params, options) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const headers = this.setHeaders(options);
                    let form = params;
                    if (options.isFormData === true) {
                        form = this.toFormData(params);
                    }
                    const response = yield axios_1.default.put(options.url, form, Object.assign(Object.assign({}, options), { timeout: options.timeout || this.timeout, headers }));
                    return response;
                }
                catch (error) {
                    throw error;
                }
            });
        }
        patch(params, options) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const headers = this.setHeaders(options);
                    let form = params;
                    if (options.isFormData === true) {
                        form = this.toFormData(params);
                    }
                    const response = yield axios_1.default.patch(options.url, form, Object.assign(Object.assign({}, options), { timeout: options.timeout || this.timeout, headers }));
                    return response;
                }
                catch (error) {
                    throw error;
                }
            });
        }
        delete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const headers = this.setHeaders(options);
                    const response = yield axios_1.default.delete(options.url + '/' + id, Object.assign(Object.assign({}, options), { timeout: options.timeout || this.timeout, headers }));
                    return response;
                }
                catch (error) {
                    throw error;
                }
            });
        }
        setHeaders(options) {
            const getAccessToken = index_1.authService.getAccessToken();
            const headers = Object.assign(this.defaultHeaderOptions, options.headers);
            // set default header authorization
            headers.authorization = 'bearer ' + getAccessToken;
            if (options.authorized === false) {
                delete headers.authorization;
            }
            // we replace the current default get access token from the options if present
            if (typeof options.headers !== 'undefined' && options.headers.authorization) {
                headers.authorization = options.headers.authorization;
            }
            return headers;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        toFormData(data) {
            // Create form data
            const form = new FormData();
            if (data.image.length !== 0) {
                form.append('image', data.image[0]);
            }
            if (data.workspaceId) {
                form.append('workspaceId', data.workspaceId);
            }
            if (data.data) {
                form.append('data', JSON.stringify(data.data));
            }
            if (data.viewed) {
                form.append('viewed', data.viewed);
            }
            return form;
        }
        isPaginatedResponse(response) {
            if (response.data.hasOwnProperty('pageCount') &&
                response.data.hasOwnProperty('page') &&
                response.data.hasOwnProperty('data') &&
                response.data.hasOwnProperty('count') &&
                response.data.hasOwnProperty('total')) {
                return true;
            }
            return false;
        }
    }
    __decorate([
        http_retry_1.Retry()
    ], HttpService.prototype, "get", null);
    __decorate([
        http_retry_1.Retry()
    ], HttpService.prototype, "post", null);
    __decorate([
        http_retry_1.Retry()
    ], HttpService.prototype, "put", null);
    __decorate([
        http_retry_1.Retry()
    ], HttpService.prototype, "patch", null);
    __decorate([
        http_retry_1.Retry()
    ], HttpService.prototype, "delete", null);
    return HttpService;
})();
exports.HttpService = HttpService;
